import BreadCrumbs from 'components/breadcrumbs'
import PMBTabSwitcher from 'components/PMBTabSwitcher'
import { useState } from 'react'
import { ChevronLeft } from 'react-feather'
import { useNavigate, useParams } from 'react-router-dom'
import { Col, Row, Spinner } from 'reactstrap'
import { URL_WAGE_SALARY } from 'utils/pathUrl'
import {
  useGetDetailBatchListQuery,
  useGetDetailBatchQuery,
} from '../employee-payments/employeePaymentsListApiSlice'
import TabPaymentDue from './TabPaymentDue'
import TabWorkRecords from './TabWorkRecords'
import WageSalaryFooter from './WageSalaryFooter'

const WageSalaryDetail = () => {
  const [activeTab, setActiveTab] = useState('workRecords')
  const navigate = useNavigate()
  const { id } = useParams()

  const [currentPage, setCurrentPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [search, setSearch] = useState('')
  const [sortColumn, setSortColumn] = useState('createdAt')
  const [sortDirection, setSortDirection] = useState('DESC')
  const [from, setFrom] = useState('')
  const [to, setTo] = useState('')

  const { data: batchData } = useGetDetailBatchQuery(
    { batchId: id },
    { skip: !id }
  )

  const {
    data: batchListData,
    isLoading: isLoadingDetails,
    isFetching,
    refetch,
  } = useGetDetailBatchListQuery(
    {
      batchId: id,
      page: currentPage,
      size: rowsPerPage,
      search,
      sortby: sortColumn,
      sortdir: sortDirection,
      from,
      to,
    },
    { skip: !id, refetchOnMountOrArgChange: true }
  )

  const [selectedRows, setSelectedRows] = useState([])

  const handleTabChange = (tab) => {
    setActiveTab(tab)
  }

  const items = Array.isArray(batchListData)
    ? batchListData
    : batchListData?.items || []

  const totalItems = Array.isArray(batchListData)
    ? batchListData.length
    : batchListData?.totalItems || items.length || 0

  return (
    <div className="w-100 px-3 pb-5 mb-5">
      <div className="mt-3">
        <BreadCrumbs
          breadCrumbParent="Wage & Salary"
          breadCrumbParentLink={URL_WAGE_SALARY}
          breadCrumbActive={`Batch ${batchData?.batchName || id || 'Detail'}`}
        />
      </div>

      {/* HEADER SECTION */}
      <Row className="mb-4 align-items-end g-3">
        <Col xs="12">
          <div className="d-flex align-items-start">
            <ChevronLeft
              size={26}
              className="me-2 mt-1"
              style={{ cursor: 'pointer', color: '#101828' }}
              onClick={() => navigate(URL_WAGE_SALARY)}
            />
            <div className="d-flex flex-column">
              <h5
                className="mb-1 fw-bold"
                style={{ fontSize: '24px', letterSpacing: '-0.5px', color: '#101828' }}
              >
                Wage & Salary
              </h5>
              <p className="text-muted mb-0" style={{ fontSize: '15px' }}>
                Kelola catatan kerja, pembayaran yang akan dibayarkan, dan ringkasan.
              </p>
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col xs="12">
          <PMBTabSwitcher
            activeTab={activeTab}
            tabs={[
              { key: 'workRecords', label: 'Work Records / Catatan Kerja' },
              { key: 'paymentDue', label: 'Payment Due / Pembayaran' },
              // { key: 'summary', label: 'Summary / Ringkasan' },
            ]}
            onTabChange={handleTabChange}
          />
        </Col>
      </Row>

      <Row>
        <Col xs="12">
          {activeTab === 'workRecords' && (
            <TabWorkRecords
              items={items}
              totalItems={totalItems}
              isLoading={isLoadingDetails || isFetching}
              batchData={batchData}
              currentPage={currentPage}
              rowsPerPage={rowsPerPage}
              setCurrentPage={setCurrentPage}
              setRowsPerPage={setRowsPerPage}
              search={search}
              setSearch={setSearch}
              sortColumn={sortColumn}
              setSortColumn={setSortColumn}
              sortDirection={sortDirection}
              setSortDirection={setSortDirection}
              from={from}
              setFrom={setFrom}
              to={to}
              setTo={setTo}
              refetch={refetch}
              selectedRows={selectedRows}
              onSelectedRowsChange={setSelectedRows}
            />
          )}
          {activeTab === 'paymentDue' && (
            <TabPaymentDue
              items={items}
              totalItems={totalItems}
              selectedRows={selectedRows}
              isLoading={isLoadingDetails}
              batchData={batchData}
              currentPage={currentPage}
              rowsPerPage={rowsPerPage}
              setCurrentPage={setCurrentPage}
              setRowsPerPage={setRowsPerPage}
            />
          )}
          {activeTab === 'summary' && (
            <div className="text-center p-5 text-muted">
              Fitur Ringkasan belum tersedia
            </div>
          )}
        </Col>
      </Row>

      <WageSalaryFooter
        batchData={batchData}
        items={items}
        selectedRows={selectedRows}
      />
    </div>
  )
}

export default WageSalaryDetail
